var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Toolbar4'),_c('FaqMain'),_c('Footer4Entry')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }